<ng-template [ngIf]="config">
  <div class="form-group">
      <ion-label class="form-label">
        {{config.label | multiLang}}
        <ng-template [ngIf]="config.required">
          <ion-text color="danger">*</ion-text>
        </ng-template>
      </ion-label>
      <ion-list>
        <div [formArrayName]=config.name *ngFor="let option of config.options; let i = index">
          <ion-item>
            <ion-checkbox  slot="start" [formControlName]="i"></ion-checkbox>
            {{option.label | multiLang}}
          </ion-item>
        </div>
      </ion-list>
      <div *ngIf="config.required && control.invalid">
        <ion-text color="danger" class="m-b-5">
          <span class="f-12 m-l-20" aria-live="assertive">{{requiredErrorMessage}}</span>
        </ion-text>
      </div>
  </div>
  
</ng-template>
